<template>
  <div class="d-flex flex-column justify-center ma-0 pa-0">
    <!-- file -->
    <input
      ref="file"
      :accept="accept"
      :disabled="disabled"
      hidden
      :multiple="multiple"
      type="file"
      @change="fileChange"
    />
    <div
      v-if="isCanChooseFile"
      class="file__upload text-center full-width py-4"
      :class="[drag ? 'drag' : '']"
      @click="goAddFile"
      @dragenter="
        if (disabled) return
        overrideDefault($event)
        hoverDrag()
      "
      @dragleave="
        if (disabled) return
        overrideDefault($event)
        hoverDragEnd()
      "
      @dragover="
        if (disabled) return
        overrideDefault($event)
        hoverDrag()
      "
      @drop="
        if (disabled) return
        overrideDefault($event)
        hoverDragEnd()
        fileChange($event)
      "
    >
      <v-icon size="30">mdi-paperclip</v-icon>
      <div class="mt-2">{{ title }}</div>
    </div>
    <!-- end file -->
    <template v-if="currentFiles">
      <div class="list--item--file">
        <!-- file -->
        <div
          v-for="(item, index) in currentFiles"
          :key="item.name"
          class="d-flex align-center mt-2"
        >
          <div class="d-flex align-center full-width flex-grow-1">
            <div class="flex-grow-0">
              <v-icon>mdi-file-outline</v-icon>
            </div>
            <div class="texttruncate flex-grow-1" :title="item.name">{{
              item.name
            }}</div>
          </div>
          <base-button
            class="ml-auto"
            :disabled="disabled"
            icon
            style="cursor:pointer"
            @click="removeFile(index)"
          >
            <v-icon>mdi-close</v-icon>
          </base-button>
        </div>
        <!-- end file -->
      </div>
    </template>
    <VMessages class="pt-2" color="error" :value="errorMessages" />
  </div>
</template>
<script>
import VInput from 'vuetify/lib/components/VInput/VInput.js'
export default {
  extends: VInput,
  props: {
    value: {
      required: false,
    },
    title: {
      required: true,
      type: String,
    },
    multiple: Boolean,
    accept: { type: String, default: 'image/*, video/*, application/pdf' },
    errorMessages: { type: [String, Array], default: () => [] },
  },
  data: () => ({
    files: [],
    drag: false,
  }),
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.files = value
        } else {
          this.files = null
        }
      },
    },
  },
  created() {
    this.$root.$on('rr-reset-input', () => {
      this.reset()
    })
  },
  computed: {
    isCanChooseFile() {
      return !(!this.multiple && this.currentFiles.length == 1)
    },
    currentFiles() {
      if (this.multiple) return this.files
      else if (this.files) return [this.files]
      return []
    },
  },
  methods: {
    // inputfile
    //drag event
    hoverDrag() {
      this.drag = true
    },
    hoverDragEnd() {
      this.drag = false
    },
    overrideDefault(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    goAddFile() {
      this.$refs.file.click()
    },
    fileChange(e) {
      let files = e.dataTransfer ? e.dataTransfer.files : e.target.files
      if (this.multiple)
        this.files = this.files ? [...this.files, ...files] : [...files]
      else {
        this.files = files[0]
      }
      this.$refs.file.value = ''
      this.$emit('input', this.files)
    },
    async downloadFile(item) {
      this.$emit('click:download', item)
    },
    reset() {
      this.files = []
      this.$emit('input', this.files)
    },
    removeFile(index) {
      if (this.multiple) {
        this.files.splice(index, 1)
      } else {
        this.files = null
      }
      this.$emit('input', this.files)
    },
  },
}
</script>
<style scoped>
/* effect drag */
.drag {
  border: 3px dashed var(--v-colorText-base);
}
.file__upload {
  background-color: #eceff1;
  border-radius: 6px;
  cursor: pointer;
}
.v-icon.mdi-paperclip {
  transform: rotate(45deg);
}
.ls_document {
  color: var(--v-colorText-base);
}
@media (max-width: 600px) {
  .file__upload {
    background-color: #eceff1;
    padding-left: 50px !important;
    padding-right: 50px !important;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
